export default __webpack_public_path__ + "static/media/got-it-done-613.89a311f0.mp3";